import { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { routes } from '@/router'
import {
  Badge,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Container,
} from '@mui/material'
import { HomeOutlined, AttachMoney, ReceiptOutlined, Menu } from '@mui/icons-material'
import { usePlatform } from '@/hooks'
import { isNewFeature } from '@/helpers'

export function MobileNavigation() {
  const { pathname } = useLocation()
  const { isAndroid } = usePlatform()

  const isInsuranceNew = isNewFeature('insurance')

  const navigationRoutes = useMemo(
    () => [
      {
        route: routes.dashboard,
        icon: <HomeOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.revenue,
        icon: <AttachMoney sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.fiscalNotes.index,
        icon: <ReceiptOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.menu,
        icon: (
          <Badge color="secondary" variant="dot" invisible={!isInsuranceNew}>
            <Menu sx={{ fontSize: 28 }} />
          </Badge>
        ),
      },
    ],
    [isInsuranceNew],
  )

  return (
    <Container
      sx={{
        position: 'fixed',
        bottom: isAndroid ? 12 : 0,
        left: 0,
        right: 0,
        zIndex: 999,
        py: 2,
        background:
          'linear-gradient(rgba(0, 0, 0, 0), rgba(255, 255, 255, 1) 20%)',
      }}
    >
      <Paper
        sx={{
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: 2,
        }}
        variant="elevation"
        elevation={2}
      >
        <BottomNavigation
          value={pathname}
          sx={{
            '& .MuiBottomNavigationAction-root': { paddingX: 1 },
            backgroundColor: 'transparent',
          }}
        >
          {navigationRoutes.map(({ route, icon }) => (
            <BottomNavigationAction
              key={route}
              component={Link}
              to={route}
              value={route}
              icon={icon}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Container>
  )
}
